.ds-social-links {
  @media only screen and (min-width: 993px) {
    display: flex;
  }

  &__headline {
    margin-block: 0 rem(.9375);
    margin-inline: 0;
    padding-block-start: rem(.25);
    color: var(--footer-color);
    font-family: var(--footer-font-family);
    font-size: var(--footer-social-headline-size);
    font-weight: 400;
    line-height: 1.1;
    text-align: center;

    @media only screen and (min-width: 993px) {
      margin-inline-end: rem(.625);
      margin-block-end: 0;
    }
  }

  &__list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-block: 0;
    margin-inline: calc(rem(.625) / -2);
    padding: 0;
    list-style: none;
  }

  &__item {
    padding-inline: calc(rem(.625) / 2);
  }
}
